import { render, staticRenderFns } from "./LeavesDropdown.vue?vue&type=template&id=1fc23f91&scoped=true&"
import script from "./LeavesDropdown.vue?vue&type=script&lang=js&"
export * from "./LeavesDropdown.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./LeavesDropdown.vue?vue&type=style&index=0&id=1fc23f91&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1fc23f91",
  null
  ,true
)

export default component.exports